import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import type { RealtimeEvent } from "@klantpunt/shared";
import { buildingKey } from "../features/building/useBuilding";
import { issueKey, issuesKey } from "../features/issues/useIssues";
import { myTasksKey, tasksKey } from "../features/tasks/useTasks";

/** Wijzigingen van collega's (SSE) → betreffende queries verversen. */
export function useRealtime(buildingId: string) {
  const qc = useQueryClient();
  useEffect(() => {
    if (!buildingId || typeof EventSource === "undefined") return;
    const es = new EventSource(`/api/events?buildingId=${buildingId}`);
    es.onmessage = (msg) => {
      try {
        const e = JSON.parse(msg.data) as RealtimeEvent;
        if (e.type === "building.updated") {
          void qc.invalidateQueries({ queryKey: buildingKey(buildingId) });
          void qc.invalidateQueries({ queryKey: ["materials", buildingId] });
        } else if (e.type === "task.updated") {
          void qc.invalidateQueries({ queryKey: tasksKey(buildingId) });
          void qc.invalidateQueries({ queryKey: myTasksKey });
          // Afboeken verandert de voorraad (module Materialen).
          void qc.invalidateQueries({ queryKey: ["materials", buildingId] });
          void qc.invalidateQueries({ queryKey: ["material-orders"] });
        } else if (e.type === "dossier.updated") {
          void qc.invalidateQueries({ queryKey: ["dossier", buildingId] });
          void qc.invalidateQueries({ queryKey: ["document", e.id] });
          void qc.invalidateQueries({ queryKey: ["annotations", e.id] });
          void qc.invalidateQueries({ queryKey: ["logbook", "document", e.id] });
        } else if (e.type === "visit.updated") {
          void qc.invalidateQueries({ queryKey: ["visits", buildingId] });
          void qc.invalidateQueries({ queryKey: ["visit", e.id] });
        } else {
          void qc.invalidateQueries({ queryKey: issuesKey(buildingId) });
          void qc.invalidateQueries({ queryKey: issueKey(e.id) });
        }
      } catch {
        /* negeren */
      }
    };
    return () => es.close();
  }, [buildingId, qc]);
}
